<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 16H3a3 3 0 0 1-3-3V3c0-1.712 2.426-3 4-3h9a3 3 0 0 1 3 3v10c.001.45-.1.894-.294 1.3-.02-.022-.039-.044-.06-.065l-2.757-2.757a5.952 5.952 0 0 0 1.112-3.476 6.008 6.008 0 0 0-6-6 6.006 6.006 0 0 0-6 6 6.006 6.006 0 0 0 6 6 5.945 5.945 0 0 0 3.476-1.11l2.758 2.757a.835.835 0 0 0 .064.059c-.405.195-.85.294-1.299.292Zm-5-4a4 4 0 1 1 4-4 4 4 0 0 1-4 3.994V12Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering186',
});
</script>
